import { cn } from "@/lib/utils";

interface OnboardingPrimaryButtonProps {
  label: string;
  disabled?: boolean;
  onClick: () => void;
}

/**
 * The sticky footer's action (`15984:127548`, "Large-48").
 *
 * Its own component rather than `StandardButton` because the frame's button is
 * full-width at a 48pt minimum height with a 13px label, and none of that
 * component's variants draw that — bending it with overrides would have cost
 * more classes than the button has.
 *
 * The disabled palette is native's `Button`, token for token: the background
 * token alone is not enough, because in light mode
 * `background/brand/primary/disabled` and `foreground/neutral/on-filled` are
 * **both `#fafafa`** — keeping the enabled label colour would leave an
 * invisible button rather than a disabled one. The border is transparent when
 * enabled so enabling does not move the label by a pixel.
 */
const OnboardingPrimaryButton = ({
  label,
  disabled = false,
  onClick,
}: OnboardingPrimaryButtonProps) => (
  <button
    type="button"
    disabled={disabled}
    onClick={onClick}
    className={cn(
      "focus-blue flex min-h-[48px] w-full items-center justify-center rounded-lg border p-3 transition-colors",
      disabled
        ? "border-border-token-neutral-minimal bg-bg-brand-primary-disabled"
        : "border-transparent bg-bg-brand-primary-default hover:bg-bg-brand-primary-hover active:bg-bg-brand-primary-active",
    )}
  >
    <span
      className={cn(
        "label-m-medium",
        disabled ? "text-fg-neutral-minimal" : "text-fg-neutral-onFilled",
      )}
    >
      {label}
    </span>
  </button>
);

export default OnboardingPrimaryButton;
